<template>
  <div class="help-texts" id="helpText" tabindex="0">
    <img src="../assets/Info-circle-filled.svg" alt="info icon" class="help-texts__icon" aria-hidden="true" />
    <div class="help-texts-flex">
      <div class="help-texts__content">
        <p v-if="$i18n.te(`messages.${textType}`)" class="help-texts__content" v-html="$t(`messages.${textType}`)"></p>
        <ul v-if="$i18n.te(`messages.${textType}_sub.1`)" class="mt-2">
          <template v-for="(key, index) in 10">
            <li class="help-texts__content" v-if="$i18n.te(`messages.${textType}_sub.${index + 1}`)" :key="key">
              {{ $t(`messages.${textType}_sub.${index + 1}`) }}
            </li>
          </template>
        </ul>
        <span
          class="help-texts__content"
          v-if="$i18n.te(`messages.${textType}_post`)"
          v-html="$t(`messages.${textType}_post`)"
        ></span>
      </div>
      <div class="help-texts__content">
        <p
          v-if="$i18n.te(`messages.${textType}_vm`)"
          class="help-texts__content"
          v-html="$t(`messages.${textType}_vm`)"
        ></p>
        <ul v-if="$i18n.te(`messages.${textType}_vm_sub.1`)" class="mt-2">
          <template v-for="(key, index) in 10">
            <li class="help-texts__content" v-if="$i18n.te(`messages.${textType}_vm_sub.${index + 1}`)" :key="key">
              {{ $t(`messages.${textType}_vm_sub.${index + 1}`) }}
            </li>
          </template>
        </ul>
        <span
          class="help-texts__content"
          v-if="$i18n.te(`messages.${textType}_fin`)"
          v-html="$t(`messages.${textType}_fin`)"
        ></span>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    textType: {
      type: String,
      default: '',
    },
  },
}
</script>
